/**
 * /en/admin/structure/types/manage/find_a_location/fields
 */
import Element from '../core/element.es6.js';
import Field from "../core/field.es6.js";

export default class FindALocationResultsContentType extends Element {
  get awayLabel() {
    return new Field({
      machineName: 'field_away_label',
      parentElement: this,
    });
  }

  get countLabel() {
    return new Field({
      machineName: 'field_count_label',
      parentElement: this,
    });
  }

  get directionsLabel() {
    return new Field({
      machineName: 'field_directions_label',
      parentElement: this,
    });
  }

  get mileslabel() {
    return new Field({
      machineName: 'field_miles_label',
      parentElement: this,
    });
  }

  get ofLabel() {
    return new Field({
      machineName: 'field_of_label',
      parentElement: this,
    });
  }

  get pageLabel() {
    return new Field({
      machineName: 'field_page_label',
      parentElement: this,
    });
  }

  get todaysHoursLabel() {
    return new Field({
      machineName: 'field_todays_hours_label',
      parentElement: this,
    });
  }

  get viewLocationDetailsLabel() {
    return new Field({
      machineName: 'field_view_loc_details_label',
      parentElement: this,
    });
  }

  constructor() {
    super({ selector: '.location-results-grid--wrapper' });
  }
}
